export default "__VITE_ASSET__ce8eb36c__"